import { SplashMap } from './splash-map';
import { CustomLogo } from './customlogo';
import { Menu } from './menu';
import { VenueMap } from './venue-detail';
import { Listing } from './listing';
import { EventTheme } from './event-theme';
import { HideImage } from './hideImage';
import { Disclaimer } from './disclaimer';
import { DisableFeatures } from './disableFeatures';
import { PrefSession } from './prefSession';

export class EventPreferences {
    theme = new EventTheme();
    splash_map = new SplashMap();
    custom_logo = new CustomLogo();
    venue = new VenueMap();
    menu = new Menu();
    listing = new Listing();
    hideImage = new HideImage();

    disclaimer = new Disclaimer();
    disableFeatures = new DisableFeatures();

    session = new PrefSession();

}


// WEBPACK FOOTER //
// /app/src/app/core/models/event-preferences.ts